import * as React from 'react';
import {
    View,
    Text,
    Image,
    StyleSheet,
} from "react-native";
import { ScrollView } from 'react-native-gesture-handler';

import { AnalyticsService } from '../constants/Analytics';
import { CartContext } from '../contexts/cart/Store';
import { AuthContext } from '../contexts/auth/Store';
import { HistoryContext } from '../contexts/history/Store';
import FontStyles from '../constants/FontStyle';
import GenericHeader from '../components/headers/GenericHeader';
import ProductList from '../components/product/ProductList';
import { ProductContext } from '../contexts/product/Store';

const analytics = new AnalyticsService

const HistoryScreen = function () {

    const auth = React.useContext(AuthContext)
    const buyer = auth.getUserData.buyerData

    const { product_state } = React.useContext(ProductContext)
    const [cart_state, cart_dispatch] = React.useContext(CartContext)
    const [history_state, history_dispatch, history_fetch] = React.useContext(HistoryContext)

    const [history, setHistory] = React.useState(null)

    const foundInCart = (item) => {
        let list = cart_state.order_group_items.filter(x => {
            return x.product_id === item?._id
        })
        if (list.length) {
            return list[0]
        }
        return false
    }

    const filterHistory = () => {
        if (!cart_state.order_group || !Object.keys(product_state.route_fulfilments).length) {
            setHistory(null)
            return []
        }
        let _h = history_state?.product_history?.filter(x => (
            !foundInCart(x) &&
            !(
                x.manufacturer.status === 'inactive' ||
                (
                    product_state &&
                    product_state?.route_fulfilments[x.manufacturer._id] &&
                    !product_state?.route_fulfilments[x.manufacturer._id].found
                )
            )
        ))
        if (_h.length) {
            setHistory(_h)
            return _h
        }
        setHistory(null)
        return []
    }

    React.useEffect(() => {
        filterHistory()
        return () => { }
    }, [history_state, cart_state, product_state])


    return (
        <>{/* RECENTLY PURCHASED */}
            <GenericHeader title="Recent Purchase" />
            {
                history?.length
                    ? <View style={styles.scrollContainer}>
                        <ProductList
                            productList={history}
                        />
                    </View>
                    : <ScrollView contentContainerStyle={{
                        paddingHorizontal: 16,
                        paddingBottom: 16,
                        flexGrow: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                        <Image source={require('../assets/images/main/folder-grey.png')} style={styles.emptyImage} />
                        <Text style={styles.emptyText}>No recently purchased items.</Text>
                    </ScrollView>
            }
        </>
    )
}

export default HistoryScreen

const styles = StyleSheet.create({
    scrollContainer: {
        flex: 1,
    },
    recentPurchaseContainer: {
        paddingHorizontal: 11,
        paddingVertical: 16,
        flexDirection: 'row',
        flexWrap: 'wrap',
        flexGrow: 1,
    },
    recentPurchaseItem: {
        width: '50%',
        paddingHorizontal: 5,
        marginBottom: 10,
    },
    emptyImage: {
        width: 50,
        height: 40
    },
    emptyText: {
        maxWidth: 215,
        ...FontStyles.normal,
        ...FontStyles.size14,
        ...FontStyles.lh20,
        ...FontStyles.gray,
        textAlign: 'center',
        marginTop: 18,
    }
})